import React from 'react'
import classnames from 'classnames/bind'
import type { Node } from '../../../types'
import Text from '../text'
import Icon from '../icon'
import JsonViewer from '../jsonViewer'
import { AutomationTarget } from '../../../types'
import useBreakpoints from '../../../hooks/useBreakpoints'
import CardContainer from '../cardContainer'
import { ColorNames } from '../../../constants/colorVars'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface JsonBeforeAfterProps extends AutomationTarget {
  before: Node
  after: Node
  beforeTitle?: string
  afterTitle?: string
  showAfterOnly?: boolean
  afterOnlyTitle?: string
  className?: string
}

const JsonBeforeAfter: React.FC<JsonBeforeAfterProps> = ({
  before,
  after,
  beforeTitle = 'Current',
  afterTitle = 'Proposed Changes',
  showAfterOnly = false,
  afterOnlyTitle = 'Changes',
  className,
}) => {
  const breakpoint = useBreakpoints()
  return showAfterOnly ? (
    <div className={cx('one-column-layout', className)}>
      <div className={cx('column')}>
        <CardContainer
          padding='small'
          borderStyle='gradient'
          borderColor={ColorNames.Success}
        >
          <Text weight='heavy'>{afterOnlyTitle}</Text>
          <JsonViewer data={after} />
        </CardContainer>
      </div>
    </div>
  ) : (
    <div className={cx('three-column-layout', className)}>
      <div className={cx('column')}>
        <CardContainer
          padding='small'
          borderStyle='gradient'
          borderColor={ColorNames.Info}
        >
          <Text weight='heavy'>{beforeTitle}</Text>
          <JsonViewer data={before} />
        </CardContainer>
      </div>
      <div className={cx('column', 'icon-column')}>
        <Icon
          name={
            breakpoint === 'mobile' || breakpoint === 'tablet'
              ? 'circle-arrow-down'
              : 'circle-arrow-right'
          }
          color={ColorNames.GrayMedium}
          iconStyle='light'
          size='huge'
        />
      </div>
      <div className={cx('column')}>
        <CardContainer
          padding='small'
          borderStyle='gradient'
          borderColor={ColorNames.Success}
        >
          <Text weight='heavy'>{afterTitle}</Text>
          <JsonViewer data={after} />
        </CardContainer>
      </div>
    </div>
  )
}

export default JsonBeforeAfter
